import Global from "./global";

export const format = value => (value || "").replace(/\n/g, "<br>").replace(/ /g, "&nbsp;");

export const vueFormat = value => {
    let comps = (value || "").split("\n");
    let result = [comps[0]];
    for (let i = 1; i < comps.length; i++) {
        result.push(Global.app.$createElement("br"), comps[i]);
    }
    return result;
};

export const getNumber = value => {
    switch (typeof value) {
        case "number":
            return value;
        case "string":
            return value.trim() ? +value.trim() : null;
        default:
            return null;
    }
};

export const toFixed = (value, fractionDigits) => {
    let number = getNumber(value);
    return number === null ? null : number.toFixed(fractionDigits || 0);
};

export const getDate = (value) => (value === null || value === void(0)) ? null : new Date(value);

function sanitize(text) {
    return text.replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export const highlight = (text, keyword) => {
    if (typeof text === "number" || text) {
        text = text.toString();
    }
    text = sanitize(text || "");
    if (!keyword) {
        return text;
    }
    let re = new RegExp(escapeRegExp(sanitize(keyword)), 'gi');
    return text.replace(re, `<strong class="text-primary">$&</strong>`)
};